(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-otp-verification-popup"] && !Shopify.designMode) return;
  try {
    
  class CartOtpPopup extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('.cart-otp-popup__overlay'); this.dialog = this.querySelector('.cart-otp-popup__dialog'); this.form = this.querySelector('form'); this.phoneStep = this.querySelector('.cart-otp-popup__phone-step'); this.verifyStep = this.querySelector('.cart-otp-popup__verify-step'); this.email = this.querySelector('[name="email"]'); this.phone = this.querySelector('[name="phone"]'); this.otp = this.querySelector('[name="otp"]'); this.status = this.querySelector('.cart-otp-popup__status'); this.captcha = this.querySelector('.cart-otp-popup__captcha'); this.sendButton = this.querySelector('[type="submit"]'); this.lastFocused = null; this.requestId = null; this.sdkReady = null;
      this.querySelector('.cart-otp-popup__launch').addEventListener('click', () => this.open()); this.querySelector('.cart-otp-popup__close').addEventListener('click', () => this.close()); this.overlay.addEventListener('click', (event) => { if (event.target === this.overlay) this.close(); }); this.dialog.addEventListener('keydown', (event) => { if (event.key === 'Escape') this.close(); });
      this.form.addEventListener('submit', (event) => { event.preventDefault(); this.send(); }); this.querySelector('[data-verify]').addEventListener('click', () => this.verify()); this.querySelector('[data-resend]').addEventListener('click', () => this.send(true)); this.querySelector('[data-change-number]').addEventListener('click', () => this.changeNumber());
      this.setupCheckoutGate(); if (this.dataset.trigger === 'page_load' && !this.isVerified()) window.setTimeout(() => this.open(), 350);
    }
    setupCheckoutGate() { if (this.dataset.gateCheckout !== 'true') return; const checkoutSelector = 'button[name="checkout"], input[name="checkout"], a[href^="/checkout"], .shopify-payment-button__button, [data-shopify="payment-button"] button'; document.addEventListener('click', (event) => { const checkout = event.target.closest(checkoutSelector); if (checkout && !this.isVerified()) { event.preventDefault(); event.stopImmediatePropagation(); this.pendingCheckout = checkout; this.open(); this.setStatus('Please verify your mobile number before proceeding.', ''); } }, true); }
    open() { this.lastFocused = document.activeElement; this.overlay.hidden = false; document.body.classList.add('cart-otp-popup--open'); this.dialog.focus(); window.setTimeout(() => (this.verifyStep.hidden ? this.phone : this.otp).focus(), 50); }
    close() { this.overlay.hidden = true; document.body.classList.remove('cart-otp-popup--open'); if (this.lastFocused) this.lastFocused.focus(); }
    isVerified() { return sessionStorage.getItem(this.dataset.storageKey) === 'verified'; }
    setStatus(message, state) { this.status.textContent = message; this.status.className = `cart-otp-popup__status ${state ? `is-${state}` : ''}`; }
    validPhone() { return /^[0-9]{6,15}$/.test(this.phone.value.replace(/\D/g, '')); }
    validEmail() { return !this.email || (!this.email.required && !this.email.value.trim()) || this.email.validity.valid; }
    loadSdk() { if (this.sdkReady) return this.sdkReady; if (!this.dataset.msg91WidgetId || !this.dataset.msg91Token) return Promise.reject(new Error('Add the MSG91 Widget ID and OTP Widget Token in this section’s Theme Editor settings.')); this.sdkReady = new Promise((resolve, reject) => { const waitForMethods = (attempt = 0) => { if (typeof window.sendOtp === 'function' && typeof window.retryOtp === 'function' && typeof window.verifyOtp === 'function') return resolve(); if (attempt >= 50) return reject(new Error('MSG91 OTP Widget is still loading. Please try again in a moment.')); window.setTimeout(() => waitForMethods(attempt + 1), 100); }; const initialise = () => { try { window.initSendOTP({ widgetId: this.dataset.msg91WidgetId, tokenAuth: this.dataset.msg91Token, identifier: '', exposeMethods: true, captchaRenderId: this.captcha.id, success: () => {}, failure: () => {}, var: 'OTP' }); waitForMethods(); } catch (error) { reject(error); } }; if (window.initSendOTP) { initialise(); return; } const script = document.createElement('script'); script.src = 'https://verify.msg91.com/otp-provider.js'; script.async = true; script.onload = initialise; script.onerror = () => reject(new Error('MSG91 OTP Widget could not load. Check your connection and Widget settings.')); document.head.appendChild(script); }); return this.sdkReady; }
    fullPhone() { return `${this.dataset.countryCode.replace(/\D/g, '')}${this.phone.value.replace(/\D/g, '')}`; }
    errorMessage(error) { return error?.message || error?.error || error?.data?.message || 'Unable to complete this request. Please try again.'; }
    async cartSnapshot() { try { const root = window.Shopify?.routes?.root || '/'; const cart = await fetch(`${root}cart.js`, { credentials: 'same-origin' }).then((response) => response.ok ? response.json() : Promise.reject(new Error('Cart unavailable'))); return { token: cart.token || this.dataset.cartToken, itemCount: cart.item_count || 0, currency: cart.currency || '', totalPrice: cart.total_price || 0, items: (cart.items || []).map((item) => ({ productId: item.product_id, variantId: item.variant_id, title: item.product_title || item.title, variant: item.variant_title || '', url: item.url ? new URL(item.url, window.location.origin).href : '', quantity: item.quantity })) }; } catch (error) { return { token: this.dataset.cartToken, itemCount: 0, currency: '', totalPrice: 0, items: [] }; } }
    async track(event, details = {}) { if (this.dataset.trackingEnabled !== 'true' || !this.dataset.trackingEndpoint) return; const cart = await this.cartSnapshot(); const payload = { timestamp: new Date().toISOString(), event, otpVerified: event === 'otp_verified', email: this.email?.value.trim() || '', phone: this.fullPhone(), pageType: this.dataset.pageType, pageUrl: window.location.href, currentProduct: this.dataset.currentProduct, currentProductUrl: this.dataset.pageType === 'product' ? window.location.href : '', msg91RequestId: this.requestId || '', error: details.error || '', cart }; const body = JSON.stringify(payload); try { const blob = new Blob([body], { type: 'text/plain;charset=UTF-8' }); if (navigator.sendBeacon && navigator.sendBeacon(this.dataset.trackingEndpoint, blob)) return; await fetch(this.dataset.trackingEndpoint, { method: 'POST', mode: 'no-cors', credentials: 'omit', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body }); } catch (error) { /* Tracking must never interrupt OTP verification or checkout. */ } }
    async send(resend = false) { const consent = this.querySelector('[name="consent"]'); if (!resend && !this.validEmail()) { this.setStatus('Enter a valid email address.', 'error'); this.email.focus(); return; } if (!resend && !this.validPhone()) { this.setStatus('Enter a valid mobile number.', 'error'); this.phone.focus(); return; } if (!resend && consent && consent.required && !consent.checked) { this.setStatus('Please accept the terms and privacy policy to continue.', 'error'); consent.focus(); return; } this.toggleLoading(true); this.setStatus(resend ? 'Resending OTP…' : 'Preparing secure verification…', ''); try { await this.loadSdk(); if (typeof window.isCaptchaVerified === 'function' && !window.isCaptchaVerified()) { this.setStatus('Please complete the CAPTCHA, then click Send OTP again.', ''); return; } this.setStatus(resend ? 'Resending OTP…' : 'Sending OTP…', ''); const data = await new Promise((resolve, reject) => { const success = (response) => resolve(response || {}); const failure = (error) => reject(error || new Error('MSG91 could not send the OTP.')); if (resend) window.retryOtp('11', success, failure, this.requestId || undefined); else window.sendOtp(this.fullPhone(), success, failure); }); this.requestId = data.reqId || data.requestId || this.requestId; await this.track(resend ? 'otp_resent' : 'otp_sent'); this.phoneStep.hidden = true; this.verifyStep.hidden = false; this.setStatus('OTP sent. Please enter it below.', 'success'); this.otp.focus(); } catch (error) { await this.track(resend ? 'otp_resend_failed' : 'otp_send_failed', { error: this.errorMessage(error) }); this.setStatus(this.errorMessage(error), 'error'); } finally { this.toggleLoading(false); } }
    async verify() { if (!this.otp.value.trim()) { this.setStatus('Enter the OTP sent to your number.', 'error'); this.otp.focus(); return; } this.toggleLoading(true); this.setStatus('Verifying OTP…', ''); try { await this.loadSdk(); const data = await new Promise((resolve, reject) => window.verifyOtp(this.otp.value.trim(), resolve, reject, this.requestId || undefined)); sessionStorage.setItem(this.dataset.storageKey, 'verified'); sessionStorage.setItem(`${this.dataset.storageKey}-msg91-token`, JSON.stringify(data || {})); await this.track('otp_verified'); this.setStatus('Your mobile number is verified.', 'success'); window.setTimeout(() => { this.close(); const destination = this.pendingCheckout || document.querySelector('button[name="checkout"], input[name="checkout"], a[href^="/checkout"]'); destination?.click(); this.pendingCheckout = null; }, 550); } catch (error) { await this.track('otp_verify_failed', { error: this.errorMessage(error) }); this.setStatus(this.errorMessage(error), 'error'); } finally { this.toggleLoading(false); } }
    changeNumber() { this.verifyStep.hidden = true; this.phoneStep.hidden = false; this.otp.value = ''; this.setStatus('', ''); this.phone.focus(); }
    toggleLoading(loading) { this.sendButton.disabled = loading; this.querySelector('[data-verify]').disabled = loading; }
  }
  if (!customElements.get('cart-otp-popup')) customElements.define('cart-otp-popup', CartOtpPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purchase-continue"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-purchase-continue]');
    if (!root) return;

    const message = root.querySelector('[data-purchase-continue-message]');
    const link = root.querySelector('.purchase-continue__link');
    const storageKey = 'daimante:purchase-gate';
    const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const params = new URLSearchParams(window.location.search);

    const fail = text => {
      message.textContent = text;
      link.hidden = false;
      root.querySelector('.purchase-continue__spinner').hidden = true;
    };

    if (params.get('form_completed') !== '1') {
      fail('Please return to the product page and complete the form before continuing.');
      return;
    }

    let intent;

    try {
      intent = JSON.parse(sessionStorage.getItem(storageKey));
    } catch (_) {
      intent = null;
    }

    if (!intent || !/^\d+$/.test(String(intent.variantId))) {
      fail('Your selected item could not be found. Please return to the product page and try again.');
      return;
    }

    fetch(`${rootUrl}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: Number(intent.variantId),
          quantity: Math.max(1, Number(intent.quantity) || 1)
        }]
      })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('The item could not be added to cart.');
        }

        sessionStorage.removeItem(storageKey);

        window.location.assign(
          `${rootUrl}${intent.action === 'checkout' ? 'checkout' : 'cart'}`
        );
      })
      .catch(() => {
        fail('We could not add your item. Please return to the product page and try again.');
      });
  })();

  } catch(e) { console.error(e); }
})();
})();
